import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { observer } from "mobx-react";
import { useStores } from "../../hooks";
import { Alert, AlertTitle } from "@material-ui/lab";




export const SnackbarComponent = observer(() => {
    const {generalStore} = useStores();

    return <Snackbar
        open={generalStore.snackbar.isOpen}
        ContentProps={{
            "aria-describedby": "message-id"
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center"}}
    >
        <Alert severity={generalStore.snackbar.type}>
            <AlertTitle>{generalStore.snackbar.title}</AlertTitle>
            {generalStore.snackbar.description}
        </Alert>
    </Snackbar>
});





